/**
 * createUserProfile module
 * Checks for the user credentials which may have expired or not exist
 * then creates the user profile item containing empty lists
 */

import appConstants from '../constants/appConstants';
import checkCredentials from '../authentication/checkCredentials';
import getUserAttributes from '../authentication/getUserAttributes';

function createUserProfile() {
  return new Promise((resolve, reject) => {
    checkCredentials().then((cognitoUser) => {
      getUserAttributes().then((userAttributes) => {
        var email = userAttributes.email;
        var username = localStorage.zmailUsername;
        var docClient = new AWS.DynamoDB.DocumentClient();
        var userId = username + '-us-east-1:' + localStorage.zmailUserId;

        var params = {
          TableName: appConstants.USER_TABLE,
          Item: {
            id: userId,
            NewProspectsList: {},
            NotifSettings: {},
            POIList: {},
            RatingBumpList: {},
            TrackedPlayers: [],
            hiddenPlayers: [],
            school: localStorage.zmailSchoolName,
            username: username,
            email: email,
          },
        };

        docClient
          .put(params)
          .promise()
          .then(() => {
            resolve();
          })
          .catch((err) => {
            console.log(err, err.stack);
            reject(err);
          });
      });
    });
  });
}

export default createUserProfile;



// WEBPACK FOOTER //
// ./src/userFunctions/createUserProfile.js